var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-bg d-flex align-items-center",style:({backgroundColor: _vm.getCategoryColor(this.text)})},[_c('div',{class:[_vm.small ? 'tag-text-small' : 'tag-text']},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }